import React, { Fragment } from 'react';
import { PieChart, Pie, ResponsiveContainer } from 'recharts';
import { Card, CardBody, Col } from 'reactstrap';
import TagOutlineIcon from 'mdi-react/ImageSizeSelectSmallIcon';
import PropTypes from 'prop-types';
import moment from "moment"; 
import ToolTip from '../../../../../shared/components/ToolTip';

import {
  Link
} from "react-router-dom";
import{
	_capitalizeText,
	_getBuildingURL,
	_formatBigNumber
} from '../../../../../shared/helpers/utils';
import { getDefaultChartColors } from '../../../../../shared/helpers';

const calculateBarData = (buildingRes) => {	
	
	let totalSold = buildingRes.inventory_sold + buildingRes.inventory_resale + buildingRes.inventory_not_yet_recorded + buildingRes.inventory_contract;
	
	if(buildingRes.inventory_bulk_sold && buildingRes.inventory_bulk_sold > 0){
		totalSold+= buildingRes.inventory_bulk_sold;
	}
	
	const totalAvail = 	buildingRes.inventory_total - totalSold;
	return [{ value: totalSold, fill: '#FFD23F' },
  				{ value: totalAvail, fill: '#DBE0E8' }];
}

const CardPercent = ( { link, buildingRes, statsRes, data } ) => {
	let total = statsRes && statsRes.total_sq_ft && statsRes.total_sq_ft.sum_sq_ft ? statsRes.total_sq_ft.sum_sq_ft : 0;
	if(statsRes && statsRes.total_sq_ft && statsRes && statsRes.total_sq_ft.count < (buildingRes.inventory_total * .9)){
		total = 0;
	}
	let sold = statsRes && statsRes.total_sellout && statsRes.total_sellout.sold_volume && statsRes.total_sellout.sold_volume.sum_sq_ft ? statsRes.total_sellout.sold_volume.sum_sq_ft : 0;
	
	const percentSold = total > 0 ? Math.round((sold / total) * 100 ) : 0;
	
	return (<CardBody className={`${link ? 'chart__link' : ''} dashboard__health-chart-card`} style={{ padding:10 }}  >
	    	<div className="card__title">
	          <div className="card__title">
		          <h5 className="bold-text card__title-center">{`% SF Sold`}
		          <ToolTip 
			        		title={`Percent sold based on total sellable square feet`} 
			        	/>	          
		          </h5>
		        </div>
	        </div>
	        <div className="dashboard__health-chart"> 
	           <ResponsiveContainer height={180}>
	            <PieChart>
	              <Pie data={data} dataKey="value"  cy={85} innerRadius={80} outerRadius={90} />
	
	            </PieChart>
	          </ResponsiveContainer>
	          <div className="dashboard__health-chart-info" style={{marginTop:-15}}>
	            <TagOutlineIcon style={{ fill: '#FFD23F' }} />
	            <p className="dashboard__health-chart-number">{percentSold > 0 ? Math.round(percentSold) : '--'}%</p>
	            <p className="dashboard__health-chart-units">sold</p>
	             
	          </div>
	           <p className="dashboard__goal">({sold > 0 ? _formatBigNumber(sold) : '0'} of {total > 0 ? _formatBigNumber(total) : 'Unknown'} sq ft)</p>
	        </div>
		</CardBody>);
};

const PercentSqFtSold = (props) => {
	const { buildingRes, statsRes, col } = props;
	
	//if(!statsRes) return null;
	const data = calculateBarData(buildingRes);
	
	
	return (
		  <Col md={12} xl={col ? col : 2} lg={6} sm={12} xs={12}>		  	
		    <Card>
		    {props.location ? 
			    <Link to={`${props.location.pathname.replace('/tab/analysis', '')}/tab/units?current_status=sold`}>
				    <CardPercent data={data} buildingRes={buildingRes} statsRes={statsRes} link />
				</Link>
			:
				<CardPercent data={data} buildingRes={buildingRes} statsRes={statsRes} />
			}
			</Card>
		  </Col>
    )
};



export default PercentSqFtSold;
